import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  static outlets = ["fonts--site-font", "site-preview"];

  selectFontPair(event) {
    const selectedElement = event.target.closest(".site-font");

    if (!selectedElement.classList.contains('selected')) {
      app.sidebar.dirty = true;
      const siteId = this.sitePreviewOutlet.siteId();
      const fontId = selectedElement.className.match(/font-pairing-(\d+)/)[1];
      const fontClass = `font-pairing-${fontId}`;

      this.fontsSiteFontOutlet.hiddenFontPairingIdTarget.value = fontId;

      $(`.selectable .selected`).removeClass("selected");
      $(`.selectable .${fontClass}`).addClass("selected");

      this.fontsSiteFontOutlet.fetcher({
        url: `/sites/${siteId}/cache_font_preview`,
        body: JSON.stringify({ key: "fontPairingId", value: fontId }),
        onSuccess: () => {
          this.sitePreviewOutlet.sync();
          this.fontsSiteFontOutlet.showPreviewActionBtns();
        },
      });
    }
  }
}
